import { renderSnapshot } from './client/cache';

import type { EchoSnapshot } from './types';
import type { LoaderFunction } from 'react-router-dom';

/**
 * This function is used to implement a fetch-then-render pattern with React Router.
 *
 * The use of a loader means that data will start fetching immediately when you click a link,
 * but the page won't transition until the fetch completes.
 */
export const echoLoader: LoaderFunction = ({ request }): Promise<EchoSnapshot> => {
  return renderSnapshot({ url: request.url, signal: request.signal });
};
